var _style, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcnEdit(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 401 401",
    style: {
      enableBackground: "new 0 0 401 401"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M383.1,35.4l-16-16c-23.9-23.9-62.7-23.9-86.7,0L37.5,262.4c-1.7,1.7-2.9,3.7-3.5,6L2.1,383.7 c-1.3,4.7,0,9.8,3.5,13.3c3.5,3.5,8.5,4.8,13.3,3.5l115.3-32c2.3-0.6,4.3-1.8,6-3.5l242.9-242.9C407,98.2,407,59.4,383.1,35.4z  M34.7,367.8L54.4,297l51.2,51.2L34.7,367.8z M363.8,102.9l-14.4,14.4l0,0l-19.3,19.3L131.3,335.4l-64.1-64.1L266,72.4l19.3-19.3 l0,0l14.4-14.4c13.3-13.3,34.8-13.3,48.1,0l16,16C377.1,68,377.1,89.6,363.8,102.9z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnEdit);
export default __webpack_public_path__ + "static/media/icn-edit.44d7db173cca466acf3134f67ac50e88.svg";
export { ForwardRef as ReactComponent };